import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {A11yModule} from '@angular/cdk/a11y';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BsModalRef , BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { DeactivateGuard } from '../../src/app/core/guards/confirm-discard';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmailValidatorDirective } from './common/validators/email-validator.directive';
import { PasswordValidatorDirective } from './common/validators/password-validator.directive';
import { CustomErrorHandler } from './core/handlers/custom.error.handler';
import { TokenInterceptor } from './core/interceptors/token-interceptor';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SharedModule } from './shared/shared.module';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        EmailValidatorDirective,
        PageNotFoundComponent,
        PasswordValidatorDirective,
        ChangePasswordComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        ModalModule,
        ToastrModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        // AngularFontAwesomeModule,
        A11yModule], providers: [
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        CookieService,
        DeactivateGuard,
        BsModalRef,
        BsModalService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {}
